'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const {Provider} = require('react-redux');
const {combineReducers, createStore, applyMiddleware} = require('redux');
const UserStore = require('../../../global/stores/UserStore');
const ContactDealerRenderer = require('../components/ContactDealerRenderer');
const authProcess = require('../../shared/helpers/relayAuthHelper');
const {constants: authConstants} = require('../../../auth/authModalLoader').default;
const { reducers } = require('dibs-contact-modal');

const store = createStore(
    combineReducers(reducers),
    applyMiddleware(require('redux-thunk').default)
);
const modalContainer = document.createElement('div');
const { track } = require('../../../global/utils/social/chat');

module.exports = options => {
    const {
        itemPk,
        linkLocation,
        dealerPk,
        sellerData,
        context,
        currentStep,
        handleCtaClick,
        modalContentData
    } = options;
    const fluxibleContext = context.getComponentContext ? context.getComponentContext() : context;
    const props = {
        itemPk,
        linkLocation,
        currentStep,
        handleCtaClick,
        modalContentData,
        dealerPk: sellerData ? sellerData.id : dealerPk
    };
    const pageCurrency = fluxibleContext.getStore(UserStore).getCurrency();

    const modalProps = Object.assign({}, props, {
        pageCurrency,
        chatTracking: track,
        startAuth: (authProps) => authProcess({...authProps, flow: authProps.makeOffer && authConstants.CONTACT_DEALER_FORM_FLOW})
    });

    ReactDOM.render(
        <Provider store={ store }>
            <ContactDealerRenderer modalProps={ modalProps }/>
        </Provider>,
        modalContainer
    );
};



// WEBPACK FOOTER //
// ./assets/js/contact/dealer/helpers/contactDealerLauncher.jsx